#import "../fragments/EmailBlockFields.graphql"

query EmailTemplate($id: ID!) {
  emailTemplate(id: $id) {
    id
    name
    updatedAt
    variants {
      language
      subject
      preheader
      blocks {
        ...EmailBlockFields
      }
    }
  }
}
